// Init bundle
const initBundle = () => {
  let boxContents = JSON.parse(localStorage.getItem('box-baby-contents') || '[]')
  const messageArray = JSON.parse(localStorage.getItem('box-baby-message') || '[]')

  const wrapper = document.querySelector('.bundle-baby')
  const currentStep = Number(wrapper.querySelector('.bundle-steps-container .step-active').dataset.step)

  console.log(boxContents)

  if (boxContents.length) {
    const list = wrapper.querySelector('.bundle-items-list')
    
    let listHtml = ''
    boxContents.forEach((elem) => {
      listHtml += `
        <div class="bundle-items-list-item py-3" role="listitem">
          <div class="row align-items-center mx-n3">
            <div class="col-4 px-3">
              <img 
                class="img-thumbnail" 
                src="${window.Shopify.resizeImage(elem.image, '240x240', 'center')}"
                alt="" 
                width="120"
                height="120"
                loading="lazy">
            </div>
            <div class="col-8 px-3">
              <p class="mb-2 small lh-sm">
                ${elem.title}
              </p>
              <p class="mb-0 lh-sm" style="font-size: .7em">
                 ${elem.variant_title} &nbsp; / &nbsp; ${window.Shopify.formatMoney(elem.price)}
              </p>
              <button 
                class="btn-remove btn btn-sm btn-link px-0"
                onclick="onRemoveBundleItem(this)"
                data-product-title="${elem.title}"
                data-unique-id="${elem.unique_id}"
                data-is-gift-wrap="${elem.is_gift_wrap}"
                aria-label="Remove"
                type="button">
                Remove
              </button>
            </div>
          </div>
        </div>
      `
    })

    list.innerHTML = listHtml
    list.removeAttribute('hidden')
    wrapper.querySelector('.bundle-items-empty').setAttribute('hidden', 'hidden')
  } else {
    wrapper.querySelector('.bundle-items-empty').removeAttribute('hidden')
    wrapper.querySelector('.bundle-items-list').setAttribute('hidden', 'hidden')
  }

  if (boxContents.length) {
    if (currentStep === 1) {
      wrapper.querySelectorAll('.btn-bundle-continue').forEach(btn => {
        btn.disabled = false
      }) 
    }
  } else {
    if (currentStep === 1) {
      wrapper.querySelectorAll('.btn-bundle-continue').forEach(btn => {
        btn.disabled = true
      }) 
    }
  }

  if (boxContents.length && messageArray.dateNeeded) {
    if (currentStep === 2) {
      wrapper.querySelectorAll('.btn-bundle-continue').forEach(btn => {
        btn.disabled = false
      }) 
    }
  } else {
    if (currentStep === 2) {
      wrapper.querySelectorAll('.btn-bundle-continue').forEach(btn => {
        btn.disabled = true
      }) 
    }
  }

  if (boxContents.length && messageArray.eventDate && messageArray.name && messageArray.saying) {
    wrapper.querySelectorAll('.btn-bundle-add-to-cart').forEach(btn => {
      btn.disabled = false
    })
  } else {
    wrapper.querySelectorAll('.btn-bundle-add-to-cart').forEach(btn => {
      btn.disabled = true
    })
  }
  
  boxContents.push({ 
    variant_id: Number(wrapper.dataset.productGiftBoxVariantId),
    price: Number(wrapper.dataset.productGiftBoxPrice)
  })
  
  const totalPrice = boxContents.reduce((accumulator, currentValue) =>
    (currentValue.price) + accumulator, 0)

  wrapper.querySelectorAll('[data-price-total]').forEach(elem => {
    elem.textContent = window.Shopify.formatMoney(totalPrice)
  })
}
initBundle()

// Bundle card - sticky position
if (window.matchMedia('(min-width: 992px)').matches) {
  const navbarHeight = document.querySelector('#navbar-desktop')?.clientHeight || 0
  const announcementBarHeight = document.querySelector('.announcement-bar ')?.clientHeight || 0

  const bundleCard = document.querySelector('.bundle-card')
  bundleCard.style.position = 'sticky'
  bundleCard.style.top = `${navbarHeight + announcementBarHeight + 20}px`
  bundleCard.style.zIndex = '1'
}

// Add to bundle 
window.addToBundle = (btn) => {
  const boxContents = JSON.parse(localStorage.getItem('box-baby-contents') || '[]')

  const title = btn.dataset.title
  const variant_id = Number(btn.dataset.variantId)
  const variant_title = btn.dataset.variantTitle
  const price = Number(btn.dataset.price)
  const image = btn.dataset.image
  const unique_id = new Date().getTime()

  const elem = {
    title,
    variant_id,
    variant_title,
    price,
    image,
    unique_id,
  }

  boxContents.push(elem)
    localStorage.setItem('box-baby-contents', JSON.stringify(boxContents))

  setTimeout(() => {
    document.querySelector('.bundle-card .card-body').scroll({ top: document.querySelector('.bundle-card .card-body').scrollHeight, behavior: 'smooth' })
  }, 500)
  
  initBundle()
}

// Remove bundle items
window.onRemoveBundleItem = (btn) => {
  let boxContents = JSON.parse(localStorage.getItem('box-baby-contents') || '[]')

  boxContents = boxContents.filter((elem) =>
    elem.unique_id !== Number(btn.dataset.uniqueId))
  localStorage.setItem('box-baby-contents', JSON.stringify(boxContents))

  goToStep(1)

  initBundle()
}

// Continue buttons
document.querySelectorAll('.btn-bundle-continue').forEach(btn => {
  btn.addEventListener('click', () => {
    const wrapper = document.querySelector('.bundle-baby')
    const currentStep = Number(wrapper.querySelector('.bundle-steps-container .step-active').dataset.step)

    goToStep(currentStep + 1)
  })
})

// Back buttons
document.querySelectorAll('.btn-bundle-go-back').forEach(btn => {
  btn.addEventListener('click', () => {
    const wrapper = document.querySelector('.bundle-baby')
    const currentStep = Number(wrapper.querySelector('.bundle-steps-container .step-active').dataset.step)

    goToStep(currentStep - 1)
  })
})

// View box summary buttons
document.querySelectorAll('.btn-bundle-view-summary').forEach(btn => {
  btn.addEventListener('click', () => {
    const wrapper = document.querySelector('.bundle-baby')

    const navbarHeight = document.querySelector('#navbar-mobile')?.clientHeight || 0
    const announcementBarHeight = document.querySelector('.announcement-bar ')?.clientHeight || 0
    wrapper.querySelector('.bundle-card').style.scrollMarginTop = `${navbarHeight + announcementBarHeight + 20}px`

    wrapper.querySelector('.bundle-card').scrollIntoView()
  })
})

function goToStep(step) {
  console.log(step)
  const wrapper = document.querySelector('.bundle-baby')

  wrapper.querySelectorAll('.bundle-steps-container [data-step]').forEach(elem => {
    elem.classList.remove('step-active')
    elem.setAttribute('hidden', 'hidden')
  })

  wrapper.querySelectorAll('.bundle-steps button').forEach(elem => {
    elem.classList.remove('active')
  })

  switch (step) {
    case 1:
      wrapper.querySelector('.bundle-steps-container [data-step="1"]').classList.add('step-active')
      wrapper.querySelector('.bundle-steps-container [data-step="1"]').removeAttribute('hidden')
      wrapper.querySelector('.bundle-steps button[data-step="1"]').classList.add('active')
      
      wrapper.querySelectorAll('.btn-bundle-continue').forEach(btn => {
        btn.removeAttribute('hidden')
      })
      wrapper.querySelectorAll('.btn-bundle-add-to-cart').forEach(btn => {
        btn.setAttribute('hidden', 'hidden')
      })
      wrapper.querySelectorAll('.btn-bundle-go-back').forEach(btn => {
        btn.setAttribute('hidden', 'hidden')
      })
      break;
    case 2:
      wrapper.querySelector('.bundle-steps-container [data-step="2"]').classList.add('step-active')
      wrapper.querySelector('.bundle-steps-container [data-step="2"]').removeAttribute('hidden')
      wrapper.querySelector('.bundle-steps button[data-step="2"]').classList.add('active')

      wrapper.querySelectorAll('.btn-bundle-continue').forEach(btn => {
        btn.removeAttribute('hidden')
      })
      wrapper.querySelectorAll('.btn-bundle-add-to-cart').forEach(btn => {
        btn.setAttribute('hidden', 'hidden')
      })
      wrapper.querySelectorAll('.btn-bundle-go-back').forEach(btn => {
        btn.removeAttribute('hidden')
      })
      break;
    case 3:
      wrapper.querySelector('.bundle-steps-container [data-step="3"]').classList.add('step-active')
      wrapper.querySelector('.bundle-steps-container [data-step="3"]').removeAttribute('hidden')
      wrapper.querySelector('.bundle-steps button[data-step="3"]').classList.add('active')

      wrapper.querySelectorAll('.btn-bundle-continue').forEach(btn => {
        btn.setAttribute('hidden', 'hidden')
      })
      wrapper.querySelectorAll('.btn-bundle-add-to-cart').forEach(btn => {
        btn.removeAttribute('hidden')
      })
      wrapper.querySelectorAll('.btn-bundle-go-back').forEach(btn => {
        btn.removeAttribute('hidden')
      })
      break;
  }

  const navbarHeight = document.querySelector('#navbar-desktop')?.clientHeight || 0
  const announcementBarHeight = document.querySelector('.announcement-bar ')?.clientHeight || 0
  wrapper.style.scrollMarginTop = `${navbarHeight + announcementBarHeight + 20}px`
  wrapper.scrollIntoView({ behavior: 'smooth'})

  initBundle()
}

// // Bundle steps
// document.querySelectorAll('.bundle-steps button').forEach(btn => {
//   btn.addEventListener('click', () => {
//     const wrapper = document.querySelector('.bundle-baby')
//     const currentStep = Number(wrapper.querySelector('.bundle-steps-container .step-active').dataset.step)

//     document.querySelectorAll('.bundle-steps-container [data-step]').forEach(elem => {
//       elem.setAttribute('hidden', 'hidden')

//       if (elem.dataset.step === btn.dataset.step) {
//         elem.removeAttribute('hidden')
//       }
//     })
//   })
// })

// Populate bundle message
const popuplateBundleMessage = () => {
  const messageArray = JSON.parse(localStorage.getItem('box-baby-message') || '[]')
  console.log(messageArray)

  const wrapper = document.querySelector('.bundle-baby')
  const dateNeeded = wrapper.querySelector('#bundle-message-date-needed')
  const eventDate = wrapper.querySelector('#bundle-message-event-date')
  const name = wrapper.querySelector('#bundle-message-name')
  const saying = wrapper.querySelector('#bundle-message-saying')
  const customized = wrapper.querySelector('#bundle-message-customized')
  const instructions = wrapper.querySelector('#bundle-message-instructions')


  dateNeeded.value = messageArray.dateNeeded || ''
  eventDate.value = messageArray.eventDate || ''
  name.value = messageArray.name || ''
  saying.value = messageArray.saying || ''
  customized.value = messageArray.customized || ''
  instructions.value = messageArray.instructions || ''
}
popuplateBundleMessage()

// Save bundle message
window.saveBundleMessage = (btn) => {
  const wrapper = document.querySelector('.bundle-baby')
  const dateNeeded = wrapper.querySelector('#bundle-message-date-needed').value
  const eventDate = wrapper.querySelector('#bundle-message-event-date').value
  const name = wrapper.querySelector('#bundle-message-name').value
  const saying = wrapper.querySelector('#bundle-message-saying').value
  const customized = wrapper.querySelector('#bundle-message-customized').value
  const instructions = wrapper.querySelector('#bundle-message-instructions').value

  console.log(name)

  if (dateNeeded) {
    wrapper.querySelector('.bundle-steps-container [data-step="2"] .alert').setAttribute('hidden', 'hidden')
  } else {
    wrapper.querySelector('.bundle-steps-container [data-step="2"] .alert').removeAttribute('hidden')
    setTimeout(() => {
      wrapper.querySelector('.bundle-steps-container [data-step="2"] .alert').setAttribute('hidden', 'hidden')
    }, 3000)
  }

  if (eventDate && name && saying) {
    wrapper.querySelector('.bundle-steps-container [data-step="3"] .alert').setAttribute('hidden', 'hidden')
  } else {
    wrapper.querySelector('.bundle-steps-container [data-step="3"] .alert').removeAttribute('hidden')
    setTimeout(() => {
      wrapper.querySelector('.bundle-steps-container [data-step="3"] .alert').setAttribute('hidden', 'hidden')
    }, 3000)
  }

  localStorage.setItem('box-baby-message', JSON.stringify(
    { dateNeeded, eventDate, name, saying, customized, instructions }
  ))

  btn.textContent = 'Saved...'
  initBundle()

  setTimeout(() => {
    btn.textContent = btn.dataset.text
  }, 3000)
}

// Add bundle to cart
document.querySelectorAll('.btn-bundle-add-to-cart').forEach(btn => {
  btn.addEventListener('click', async () => {
    const wrapper = document.querySelector('.bundle-baby')
    let boxContents = JSON.parse(localStorage.getItem('box-baby-contents') || '[]')
    const messageArray = JSON.parse(localStorage.getItem('box-baby-message') || '[]')
    let cartItems = []

    const bundleId = crypto.randomUUID()

    btn.innerHTML = `
      <div class="spinner-border spinner-border-sm" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    `
    const bundleProducts = []
    let bundlePrice = 0

    boxContents.forEach(elem => {
      bundleProducts.push(`${elem.title} ${elem.variant_title}`)
      bundlePrice += elem.price
    })

    bundlePrice += Number(wrapper.dataset.productGiftBoxPrice)

    const mainProduct = { 
      id: Number(wrapper.dataset.productGiftBoxVariantId),
      quantity: 1,
      properties: {
        _bundle_main_product: true,
        _bundle_id: bundleId,
        _bundle_price: bundlePrice,
        'Bundle contents': bundleProducts.join(', '),
        ...messageArray,
      }
    }
   
    cartItems.push(mainProduct)
    
    boxContents.forEach(elem => {
      cartItems.push({
        id: elem.variant_id,
        quantity: 1,
        properties: {
          'Added to': wrapper.dataset.productGiftBoxTitle, 
          _bundle_child_product: true,
          _bundle_id: bundleId
        }
      })
    })

    cartItems = cartItems.reverse()
    console.log(cartItems)

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: cartItems })
    })

    window.refreshCartContents(response)
    // window.bootstrap.Offcanvas.getOrCreateInstance('#offcanvas-cart').show()
    document.querySelector('[href="#offcanvas-cart"]').click()
    
    btn.innerHTML = window.theme.product.addedToCart
    localStorage.removeItem('box-baby-contents')
    localStorage.removeItem('box-baby-message')

    initBundle()
    popuplateBundleMessage()
    goToStep(1)
  })
})

// Sticky bundle mobile
const initStickyBundleMobile = () => {
  const wrapper = document.querySelector('.bundle-sticky-card')

  const top = document.querySelector('.bundle-card').getBoundingClientRect().bottom + window.scrollY

  window.addEventListener('scroll', () => {
    if (window.scrollY > top) {
      wrapper.classList.add('show')
      document.body.style.paddingBottom = wrapper.clientHeight + 'px'
    } else {
      wrapper.classList.remove('show')
      document.body.style.paddingBottom = 0
    }
  })
}
initStickyBundleMobile()

// Variant change on bundle products
window.onChangeBundleProductVariant = (select) => {
  const btn  = select.closest('.product-item').querySelector('.btn-add-to-bundle')

  btn.setAttribute('data-variant-id', select.value)
  btn.setAttribute('data-variant-title', select[select.selectedIndex].dataset.title)
  btn.setAttribute('data-price', select[select.selectedIndex].dataset.price)
}

// "Pick your saying" selector change
// document.querySelectorAll('select#bundle-message-saying').forEach(elem => {
//   elem.addEventListener('change', () => {
//     if (elem.value.includes('My Own')) {

//     } else {

//     }
//   })
// })